import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'

import login from 'graphql/mutations/login'

// material-ui components
// import TextField from 'material-ui/TextField'
import withStyles from 'material-ui/styles/withStyles'
import InputAdornment from 'material-ui/Input/InputAdornment'

// material-ui-icons
import Email from 'material-ui-icons/Email'
import LockOutline from 'material-ui-icons/LockOutline'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import LoginCard from 'components/Cards/LoginCard.jsx'
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from 'components/CustomButtons/Button.jsx'

import loginPageStyle from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx'

class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
      email: '',
      password: '',
    }
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: '' })
      }.bind(this),
      700,
    )
  }

  handleChange = field => event => {
    this.setState({
      [field]: event.target.value,
    })
  }

  // handleLogin = event => {
  //   event.preventDefault()
  //   this.props
  //     .login({
  //       variables: {
  //         email: this.state.email,
  //         password: this.state.password,
  //       },
  //     })
  //     .then(({ data }) => {
  //       localStorage.setItem('token-cdp-crm', data.login.token)
  //       this.props.history.push('/home')
  //     })
  //     .catch(error => {
  //       this.setState({
  //         errore: error,
  //       })
  //     })
  // }

  handleLogin = login => event => {
    event.preventDefault()
    login({
      variables: {
        email: this.state.email,
        password: this.state.password,
      },
    })

    this.setState({
      email: '',
      password: '',
    })
  }

  handleLoggedIn = ({ login: { token, me } }) => {
    localStorage.setItem('cdpcrm_token', token)
    localStorage.setItem('cdpcrm_user', me.nome)
    localStorage.setItem('cdpcrm_email', me.email)
    localStorage.setItem('cdpcrm_role', me.ruolo)
    this.props.history.push('/home')
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <ItemGrid xs={12} sm={6} md={4}>
              <Mutation mutation={login} onCompleted={this.handleLoggedIn}>
                {(login, { data, loading, error }) => (
                  <form onSubmit={this.handleLogin(login)}>
                    <LoginCard
                      customCardClass={classes[this.state.cardAnimaton]}
                      headerColor="blue"
                      cardTitle="Accedi al CRM"
                      footerAlign="center"
                      footer={
                        <div>
                          {error && <p style={{ color: '#c00' }}>Email o password errate</p>}
                          <Button type="submit" color="primaryNoBackground" wd size="lg">
                            Accedi
                          </Button>
                        </div>
                      }
                      content={
                        <div>
                          
                          <CustomInput
                            labelText="Email"
                            id="email"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Email className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                              ),
                              value: this.state.email,
                              onChange: this.handleChange('email')
                            }}
                          />

                          <CustomInput
                            labelText="Password"
                            id="password"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <LockOutline className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                              ),
                              value: this.state.password,
                              onChange: this.handleChange('password'),
                              type: 'password'
                            }}
                          />
                          
                        </div>
                      }
                    />
                  </form>
                )}
              </Mutation>
            </ItemGrid>
          </GridContainer>
        </div>
      </div>
    )
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(loginPageStyle)(LoginPage)



// WEBPACK FOOTER //
// ./src/views/Login/LoginPage.jsx